import React from 'react';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import CONSTANTS from '../../constants';
import { GuardedRoute } from '../../shared/components/User/GuardedRoute';
import BlacklistOverview from './BlacklistOverview';

class Blacklist extends React.Component {
  render() {
    return (
      <Switch>
        <GuardedRoute
          permissions={[CONSTANTS.PERMISSIONS.OP_READ_USERS]}
          exact
          path={CONSTANTS.ROUTES.BLACKLIST_OVERVIEW.path}
          component={BlacklistOverview}
        />
        <Redirect to={CONSTANTS.ROUTES.FOUR_OH_FOUR.path} />
      </Switch>
    );
  }
}

export default withRouter(Blacklist);
